import { useEffect, useMemo, useRef, useState } from "react";

// Context
import { useSubscriptions } from "@Common/context/subscriptions/Subscriptions";

// API
import { onUpdateCustomerEngagementTrail } from "@DataPages/api/customerEngagementTrail";

// Components
import RoundedBox from "@Layouts/components/Basics/RoundedBox";
import BodyLayer from "@Layouts/components/Layers/BodyLayer";
import CommissionSideBar from "@Layouts/components/SideBars/CommissionSideBar";
import CustomerEngagementTrailBody from "./CustomerEngagementTrailBody";
// Hooks
import useCacheCleaner from "@/Common/hooks/CacheCleaner";

const QUERY_IDENTIFIERS = ["customerEngagementTrail"];

export default function CustomerEngagementTrailLayer() {
	const { clearCache } = useCacheCleaner();
	const lastSelected = useRef(null);
	const [selection, setSelection] = useState(null);
	const { addSubscription, clearSubscriptionContext } = useSubscriptions();

	const sideBar = useMemo(() => {
		const handleSelection = function (selected, isActualCycle) {
			if (selected?._id !== lastSelected.current?._id) {
				lastSelected.current = selected;
				setSelection(selected);
				if (isActualCycle) {
					addSubscription(
						["customerEngagementTrail", selected?._id],
						[
							{
								context: "onUpdateCustomerEngagementTrail",
								query: onUpdateCustomerEngagementTrail,
								variables: {
									locationId: selected.locationId,
									commissionCycleId: selected._id,
								},
							},
						]
					);
				}
			}
		};
		return <CommissionSideBar callbackSelected={handleSelection} selectDefaultLastCommissionCycle />;
	}, [addSubscription]);

	useEffect(() => {
		return () => {
			lastSelected.current = null;
			setSelection(null);
			clearSubscriptionContext();
			clearCache(QUERY_IDENTIFIERS);
		};
	}, [clearSubscriptionContext]);

	return (
		<BodyLayer fixedContent={sideBar}>
			<RoundedBox sx={{ minHeight: "630px" }} className="!pb-[48px]">
				<CustomerEngagementTrailBody
					selected={selection}
					isUpdatable={Boolean(selection?.cycleStatus === "CLOSING" || selection?.cycleStatus === "ACTIVE")}
					queryIdentifier={QUERY_IDENTIFIERS[0]}
				/>
			</RoundedBox>
		</BodyLayer>
	);
}
